import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

// Connects to data-controller="popover"
export default class extends Controller {
  connect() {
    const data = this.element.dataset;
    this.popover = new Popover(this.element, {
      title: data.title || '',
      content: this.#generateContent(data.kind, data.content),
      customClass: data.customClass || '',
      trigger: 'click',
      placement: data.placement || 'right',
      html: true
    })
    // 要素より外側がクリックされたら非表示にする
    document.addEventListener("click", (event) => this.handleOutsideClick(event));
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    const klass = event.target.parentElement.classList
    if (!klass.contains('popover') && event.target.parentElement !== this.element) {
      this.popover.hide();
    }
  }

  #generateContent(kind, content) {
    if (kind === 'image') {
      return `
        <div class="popover-content">
          <img src="${content}" alt="画像">
        </div>
      `;
    }
    return content;
  }
}
